import { Core } from "Components/core";

export class Input extends Core {
  constructor(domElem) {
    super(domElem, Input.className);
    this._val = domElem.value;
    domElem.addEventListener("change", this._onInput.bind(this));
    domElem.addEventListener("input", this._onInput.bind(this));
  }

  getVal() {
    return this._val;
  }

  setVal(val) {
    typeof val === "undefined" || (val = String(val));

    if (this._val !== val) {
      this._val = val;
      this.domElem.value !== val && (this.domElem.value = val);
      this._emit("change");
    }

    return this;
  }

  getFieldName() {
    return this.domElem.getAttribute("data-field-name") ?? this.getName();
  }

  getName() {
    return this.domElem.getAttribute("name");
  }

  _onInput(e) {
    (e.detail || {}).target == this || e.stopPropagation(); // don't stop custom event

    this.setVal(this.domElem.value);
  }

  static className = "input";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${Input.className}`).forEach((el) => {
      return new Input(el);
    });
  }
}
